module.exports = __webpack_public_path__ + "img/qrcode_frame_2.8ad70f9b.png";